import { application } from "./application";

import ModalController from "./modal_controller";
import PlanChangeController from "./plan_change_controller";
import DropdownFormController from "./dropdown_form_controller";
import DropdownController from "./dropdown_controller";
import SidebarController from "./sidebar_controller";
import ThemeController from "./theme_controller";
import ProcessingStatusController from "./processing_status_controller";
import PartyPlanController from "./party_plan_controller";
import ProductFilterController from "./product_filter_controller";
import ProductPurchaseController from "./product_purchase_controller";
import PhoneInputController from "./phone_input_controller";
import AiAssistantController from "./ai_assistant_controller";
import PaymentManagementController from "./payment_management_controller";
import PerPartyPaymentController from "./per_party_payment_controller";
import EmailRecipientController from "./email_recipient_controller";
import AiDrafterController from "./ai_drafter_controller";

// Analytics controllers
import AnalyticsDashboardController from "./analytics/dashboard_controller";
import AnalyticsChartController from "./analytics/chart_controller";
import AnalyticsFilterController from "./analytics/filter_controller";
import AnalyticsMetricCardController from "./analytics/metric_card_controller";
import AnalyticsDrillDownController from "./analytics/drill_down_controller";
import AnalyticsActivityFeedController from "./analytics/activity_feed_controller";
import FileUploadController from "./file_upload_controller";
import TabsController from "./tabs_controller";
import ToggleController from "./toggle_controller";

// Admin controllers
import SurveyBuilderController from "./survey_builder_controller";
import TicketPaymentController from "./ticket_payment_controller";

application.register("modal", ModalController);
application.register("plan-change", PlanChangeController);
application.register("dropdown-form", DropdownFormController);
application.register("dropdown", DropdownController);
application.register("sidebar", SidebarController);
application.register("theme", ThemeController);
application.register("processing-status", ProcessingStatusController);
application.register("toggle", ToggleController);
application.register("party-plan", PartyPlanController);
application.register("product-filter", ProductFilterController);
application.register("product-purchase", ProductPurchaseController);
application.register("phone-input", PhoneInputController);
application.register("ai-assistant", AiAssistantController);
application.register("email-recipient", EmailRecipientController);
application.register("file-upload", FileUploadController);
application.register("ai-drafter", AiDrafterController);
application.register("tabs", TabsController);

// Payment controllers
application.register("payment-management", PaymentManagementController);
application.register("per-party-payment", PerPartyPaymentController);
application.register("ticket-payment", TicketPaymentController);

// Register analytics controllers
application.register("analytics--dashboard", AnalyticsDashboardController);
application.register("analytics--chart", AnalyticsChartController);
application.register("analytics--filter", AnalyticsFilterController);
application.register("analytics--metric-card", AnalyticsMetricCardController);
application.register("analytics--drill-down", AnalyticsDrillDownController);
application.register(
  "analytics--activity-feed",
  AnalyticsActivityFeedController,
);

// Register admin controllers
application.register("survey-builder", SurveyBuilderController);
